module.exports = __webpack_public_path__ + "img/jigou-logo.6e8a5eef.png";